(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3646],{

/***/ 4500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* reexport */ Tooltip; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@ebay/nice-modal-react/lib/esm/index.js
var esm = __webpack_require__(25362);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/reactjs-popup/dist/reactjs-popup.esm.js
var reactjs_popup_esm = __webpack_require__(92345);
// EXTERNAL MODULE: ./components/atomic/Tooltip/tooltip.module.scss
var tooltip_module = __webpack_require__(60600);
var tooltip_module_default = /*#__PURE__*/__webpack_require__.n(tooltip_module);
// EXTERNAL MODULE: ./components/styleguide/LocoScore/index.ts + 1 modules
var LocoScore = __webpack_require__(27838);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/atomic/Tooltip/Tooltip.js













var TooltipModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5994).then(__webpack_require__.bind(__webpack_require__, 95994));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95994)
            ];
        }
    },
    ssr: false
});
var popoverStyle = {
    border: 0,
    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
    borderRadius: 24,
    padding: 24,
    zIndex: 99999,
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem"
};
var popupEvents = [
    "hover",
    "click",
    "focus"
];
var popupPositions = [
    "top center",
    "bottom center",
    "right center",
    "left center"
];
var Tooltip = function(param) {
    var id = param.id, children = param.children, title = param.title, label = param.label, _position = param.position, position = _position === void 0 ? popupPositions : _position, _width = param.width, width = _width === void 0 ? 300 : _width, _iconSize = param.iconSize, iconSize = _iconSize === void 0 ? 16 : _iconSize, icon = param.icon, rating = param.rating, onOpenModal = param.onOpenModal, onCloseModal = param.onCloseModal;
    var ref = (0,react.useState)(false), isTooltipOpen = ref[0], setIsTooltipOpen = ref[1];
    var isMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 991px)"
    });
    var onOpenTooltipModal = function() {
        if (onOpenModal) {
            onOpenModal();
        }
        esm/* default.show */.ZP.show(TooltipModal, {
            id: id,
            children: children,
            title: title,
            icon: icon,
            onCloseModal: onCloseModal
        });
    };
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            onClick: onOpenTooltipModal,
            children: icon ? icon : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !!label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function(e) {
                            return e.preventDefault();
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/library/info.svg"),
                        alt: "",
                        height: 16,
                        width: 16
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(reactjs_popup_esm/* default */.Z, {
        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: (tooltip_module_default()).button,
            onClick: function(e) {
                e.stopPropagation();
                e.preventDefault();
                (0,vehicle/* addToDataLayer */.Bk)({
                    event: "tooltip-".concat(id),
                    value: !isTooltipOpen
                });
                setIsTooltipOpen(!isTooltipOpen);
            },
            children: icon ? icon : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    !!label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function(e) {
                            return e.preventDefault();
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/library/info.svg"),
                        height: iconSize,
                        width: iconSize,
                        alt: "",
                        onClick: function(e) {
                            return e.preventDefault();
                        }
                    })
                ]
            })
        }),
        open: isTooltipOpen,
        arrow: false,
        position: position,
        contentStyle: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, popoverStyle), {
            width: width
        }),
        overlayStyle: {
            zIndex: 25
        },
        offsetY: 8,
        offsetX: 8,
        closeOnDocumentClick: true,
        on: popupEvents,
        keepTooltipInside: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (tooltip_module_default()).icon,
                children: rating ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LocoScore/* LocoScore */.o, {
                    rating: rating,
                    iconOnly: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/library/info.svg"),
                    height: 36,
                    width: 36,
                    className: (tooltip_module_default())["help-icon"],
                    alt: "",
                    onClick: function(e) {
                        return e.preventDefault();
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (tooltip_module_default()).header,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (tooltip_module_default()).content,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/atomic/Tooltip/index.js



/***/ }),

/***/ 3646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ValueScore_ValueScore; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./components/views/HomePage/ValueScore/value-score.module.scss
var value_score_module = __webpack_require__(15187);
var value_score_module_default = /*#__PURE__*/__webpack_require__.n(value_score_module);
// EXTERNAL MODULE: ./components/atomic/Tooltip/index.js + 1 modules
var Tooltip = __webpack_require__(4500);
// EXTERNAL MODULE: ./components/styleguide/LocoScore/index.ts + 1 modules
var LocoScore = __webpack_require__(27838);
// EXTERNAL MODULE: ./components/styleguide/VehicleImage/index.ts + 2 modules
var VehicleImage = __webpack_require__(52733);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/routes.js
var routes = __webpack_require__(7158);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
;// CONCATENATED MODULE: ./components/views/HomePage/ValueScore/ValueScore.js












var ValueScore = function(param) {
    var deal = param.deal, isVans = param.isVans;
    var ref, ref1;
    var ref2 = (0,react.useState)(""), url = ref2[0], setUrl = ref2[1];
    (0,react.useEffect)(function() {
        if (deal) {
            var profile = "".concat(deal.vehiclePrice.leaseType, "-").concat(deal.vehiclePrice.term, "-").concat(deal.vehiclePrice.mileage, "-").concat(deal.vehiclePrice.initialPaymentInMonths, "-").concat(deal.vehiclePrice.stockStatus);
            var newUrl = "/".concat(deal.vehiclePrice.vehicleType === constants/* FILTER_VEHICLE_TYPES_VANS */.Bz ? "van" : "car", "-leasing/").concat((0,vehicle/* getUrlReadyString */.oh)(deal.vehiclePrice.manufacturerName), "/").concat((0,vehicle/* getUrlReadyString */.oh)(deal.vehiclePrice.rangeName), "/").concat((0,vehicle/* getUrlReadyString */.oh)(deal.vehiclePrice.derivativeName), "/").concat(deal.vehiclePrice.vehicleId, "/").concat(profile, "/").concat(deal.vehiclePrice.id, "/config");
            setUrl(newUrl);
        }
    }, [
        deal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (value_score_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (value_score_module_default()).confetti
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (value_score_module_default()).grid,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (value_score_module_default()).column,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: (value_score_module_default()).heading,
                            children: [
                                "The higher the LocoScore,",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "the better the lease deal."
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (value_score_module_default()).column,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (value_score_module_default()).text,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Looking for a great price? How about great value?"
                                        }),
                                        " Our unique LocoScore algorithm rates every ",
                                        isVans ? "van" : "car",
                                        " lease deal out of 100, giving you the best value and letting you know what's hot and what's . . . not."
                                    ]
                                }),
                                isVans ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "We'll help find the right van or",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* ROUTES.homePage.url */.Z.homePage.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "car lease deals"
                                            })
                                        }),
                                        " ",
                                        "for you. Deals in the 60-69 territory can be considered average, whilst anything from 70 upwards is good value. And 100? Well, you're dreaming."
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "We'll help find the right",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: routes/* ROUTES.vanHomePage.url */.Z.vanHomePage.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "van"
                                            })
                                        }),
                                        " ",
                                        "or",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/car-leasing/search",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "car lease deals"
                                            })
                                        }),
                                        " ",
                                        "for you. Deals in the 60-69 territory can be considered average, whilst anything from 70 upwards is good value. And 100? Well, you're dreaming."
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((value_score_module_default()).grid, " ").concat((value_score_module_default())["has-no-mobile-margin"]),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (value_score_module_default()).column,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (value_score_module_default())["data-points"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (value_score_module_default()).data,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Value at",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "a glance"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Easily see the best value"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (value_score_module_default()).data,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Dynamic",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "scoring"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Tailored to your terms"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((value_score_module_default()).data, " ").concat((value_score_module_default())["desktop-margin-top"]),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Real-time",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "comparison"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Based on all available deals"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((value_score_module_default()).data, " ").concat((value_score_module_default())["desktop-margin-top"]),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "Lease with",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                "confidence"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "With our LocoScore"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((value_score_module_default()).column, " ").concat((value_score_module_default())["is-visible"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (value_score_module_default()).vehicle,
                            children: deal && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (value_score_module_default())["vehicle-data"],
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                                                id: "loco-score-helper",
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocoScore/* LocoScore */.o, {
                                                    className: (value_score_module_default()).score,
                                                    rating: deal.vehiclePrice.rating,
                                                    iconOnly: true
                                                }),
                                                rating: deal.vehiclePrice.rating,
                                                title: "LocoScore",
                                                iconSize: 16,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Powered by our lease comparison algorithm this score indicates how good a deal really is.",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: routes/* ROUTES.locoScorePage.url */.Z.locoScorePage.url,
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                target: "_blank",
                                                                children: [
                                                                    "Learn more",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "sr-only",
                                                                        children: " about the Loco Score"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (value_score_module_default())["vehicle-name"],
                                                children: [
                                                    deal.vehiclePrice.manufacturerName,
                                                    " ",
                                                    deal.vehiclePrice.rangeName
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: (value_score_module_default())["vehicle-derivative"],
                                                children: deal.vehiclePrice.derivativeName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: url,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    children: [
                                                        "View vehicle",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: "".concat(constants/* constants.imageHost.assets */._G.imageHost.assets, "/icons/library/chevron-right.svg"),
                                                            height: "16",
                                                            width: "16",
                                                            alt: "chevron right icon"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (value_score_module_default())["vehicle-image"],
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                                            triggerOnce: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleImage/* VehicleImage */.o, {
                                                imagePath: (ref = deal.vehicle.gallery) === null || ref === void 0 ? void 0 : (ref1 = ref.images) === null || ref1 === void 0 ? void 0 : ref1.filter(function(img) {
                                                    return img.angle === "sideview";
                                                })[0].path,
                                                backupImagePath: deal.vehicle.images.side,
                                                alt: "".concat(deal.vehicle.manufacturerName, " ").concat(deal.vehicle.modelName),
                                                height: 630,
                                                width: 945,
                                                type: "HOMEPAGE"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ValueScore_ValueScore = (ValueScore);

;// CONCATENATED MODULE: ./components/views/HomePage/ValueScore/index.js



/***/ }),

/***/ 60600:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"tooltip_button__kYj61","modal":"tooltip_modal__OqtId","icon":"tooltip_icon__d9OTD","button--dismiss":"tooltip_button--dismiss__s3ZQU","header":"tooltip_header__s5oih","help-icon":"tooltip_help-icon__CXKeb","content":"tooltip_content__6DxBQ","tooltip-link":"tooltip_tooltip-link__A90JK","tooltip-modal-overlay":"tooltip_tooltip-modal-overlay__jGlV_","phAnimation":"tooltip_phAnimation__wcT96"};

/***/ }),

/***/ 15187:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"value-score_container__41Fxq","grid":"value-score_grid__pz317","column":"value-score_column__hT2qC","heading":"value-score_heading__BAUc3","text":"value-score_text__KAKeO","has-no-mobile-margin":"value-score_has-no-mobile-margin__47zQK","data-points":"value-score_data-points__Dgx1G","data":"value-score_data__GRNio","is-visible":"value-score_is-visible__HZTau","vehicle":"value-score_vehicle__23Uyb","vehicle-data":"value-score_vehicle-data__VJwRY","vehicle-name":"value-score_vehicle-name__ItwOK","vehicle-derivative":"value-score_vehicle-derivative__mdC94","vehicle-image":"value-score_vehicle-image__rXpxV","desktop-margin-top":"value-score_desktop-margin-top__WMBkl","score":"value-score_score__nBVCU","phAnimation":"value-score_phAnimation__jbnVf"};

/***/ })

}]);